import React from 'react'
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";

import FormPage from '../FormPage'
import User from "../../models/User";
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";

export default class NotificationSettings extends FormPage
{
    static path = '/account/settings';

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel auth-settings-form';

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
     * The title shown on the form
     */
	// static FormTitle = "Email Preferences";
    /**
     * The subtitle shown on the form
     */

	static FormSubtitle = "auth.edit_settings.subtitle";

	/**
     * The api endpoint path that the form should send a post request to
     */
	static FormPost = "/api/notification-settings/update";

	/**
     * The submit button title for the form
     */
	static FormSubmit = false;//"auth.edit_settings.submit_button";

    /**
     * The fields mapping for the form
     */
    formFields()
    {
        let fields = [];

        let categories = this.state.settings[this.state.selectedTabIndex].groups

        for (let category of categories) {
            if (!category.settings.length) {
                continue;
            }
            let catFields = {};

            let options = TB.sortBy(
                TB.first(category.settings).options, 'settings_type');

            options = TB.map([...options], 'settings_type')
            for (let secSettings of category.settings) {
                let secSettingsFields = {};

                for (let option of options) {

                    let setting = TB.find(secSettings.options, ['settings_type', option]);

                    if (setting) {

                        secSettingsFields[setting.settings_prop] = {
                            type: 'setting',
                            setting: {...setting},
                            name: setting.settings_prop,
                            // value: this.state.model[setting.settings_prop],
                            disabled: this.state.isDisabled,
                            required: false,
                            style: styles.field,
                            columns: 2
                        }
                    }
                }
                catFields[TB.slugify(secSettings.name)] = {
                    style: styles.fieldSection,
                    fields: {
                        [TB.kebabCase(secSettings.name + "Header")]: {
                            component: (
                                <div className="settings-label">
                                    <p className="setting-name">
                                        {secSettings.name}
                                    </p>
                                    <p className="setting-description">
                                        {secSettings.description}
                                    </p>
                                </div>
                            ),
                            columns: options.length > 1 ? 8 : 10
                        },
                        ...secSettingsFields
                    },
                }
            }

            let optionHeaders = {};



            for (let option of options) {
                if (option.length > 10) {
                    option = option.slice(0,10);
                    option += '.';
                }
                optionHeaders[TB.kebabCase(category.name + option)] = {
                    component: (
                        <div className="notifications-category-option-header">
                            <p>{option}</p>
                        </div>
                    ),
                    columns: 2
                }
            }

            fields.push({
                style: {
                    flexDirection: 'column',
                    alignItems: 'stretch'
                },
                fields: {
                    [TB.kebabCase(category.name)]: {
                        style: styles.fieldSection,
                        fields: {
                            [TB.kebabCase(category.name) + '-header']: {
                                component: (
                                    <div className="notifications-category-header">
                                        <h4>{category.name}</h4>
                                    </div>
                                ),
                                columns: options.length > 1 ? 8 : 10
                            },
                            ...optionHeaders
                        }
                    },
                    ...catFields
                },
            })
        }

    	return fields
	}

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props, context)
    {
		super(props, context);

		this.state = {
			...this.state,
			model: {},
            settings: undefined,
            selectedTabIndex: 0,
            isLoading: true,
            feedbackMessage: laravel.auth_settings_change_feedback,
		};
	}

	async componentDidMount() {
        super.componentDidMount();

        // if (this.props.queryParams?.email
        //     && this.context?.auth?.email !== this.props.queryParams?.email) {
        //     Auth.Intended = this.props.location;
        //     await TB.auth().logout();
        // }

        // if (!this.context.auth?.isTalentSupplierResource()) {
            await this.getUserNotificationSettings();
        // }
    }

    /**
     * Overridable method for mapping form input data to form submit models
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model)
    {
        let formModel = {...model}
        if (this.props.queryParams?.email) {
            formModel.email = this.props.queryParams?.email;
        }
        if (this.props.queryParams?.hash) {
            formModel.hash = this.props.queryParams?.hash;
        }

        return formModel;
    }


    async getUserNotificationSettings()
    {
        let auth = this.context?.auth;
        if (!auth) {
            if (!laravel.auth_notification_settings || !laravel.auth_notification_settings_sections) {
                return this.promisedState({
                    settings: [],
                    isLoading: false,
                    error: {title: "Something went wrong."},
                });
            }

            return this.promisedState({
                settings: [...laravel.auth_notification_settings_sections],
                model: {...laravel.auth_notification_settings},
                isLoading: false,
                error: null,
            });
        }



        // show loading feedback
        let settings = await auth.getNotificationSettings();


        if (!settings) {
            return this.handleErrorResponse(
                User.GetUserPreferencesRequest
            );
        }

        await this.promisedState({
            settings,
            model: {...(this.context?.auth?.settings || {})},
            isLoading: false,
            error: null
        });

        console.log('this.context?.auth', this.context?.auth);
        console.log('this.context?.auth?.settings', this.context?.auth?.settings);

        if (this.props.queryParams?.email && this.context?.auth?.email === this.props.queryParams?.email
            && this.state.model[this.props.queryParams?.key])
        {
            let model = {...this.state.model};

            model = TB.set(model, this.props.queryParams.key, false);

            await this.formRef.current?.updateInputsWithValue({[this.props.queryParams.key]: false});

            await this.formRef.current?.onSubmit(model);

        }
    }

    /**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
	async onSuccess(responseData)
	{
	    await TB.wait(500);
        await this.promisedState({isDisabled: false, feedbackMessage: null})

        await TB.alert(
            'success',
            'auth.edit_settings.success.title',
            'auth.edit_settings.success.message'
        );

        if (this.props.queryParams?.key) {
            await this.props.history.replace({pathname: this.constructor.path});
        }
	}


    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */
    renderFormView()
    {
        // if (this.context.auth?.isTalentSupplierResource()) {
        //     return <PageNotAllowed redirect="/talent/dashboard" />
        // }

        let panelContainerStyles = {};

        panelContainerStyles.maxWidth = this.constructor.MaxWidth;

        let {
            isLoading,
            error
        } = this.state;

        let auth = this.context?.auth;

        return (
            <div className="form-container pb-5">
                <div style={panelContainerStyles}>
                    {isLoading && <LoadingBanner/>}

                    {TB.isObject(error) && TB.isObject(auth) && (
                        <ErrorBanner
                            {...error}
                            onRetry={this.getUserNotificationSettings.bind(this)}/>
                    )}

                    {TB.isObject(error) && !TB.isObject(auth) && (
                        <ErrorBanner
                            {...error}/>
                    )}

                    {!isLoading && !TB.isObject(error) && TB.isString(this.state.feedbackMessage) && (
                        <div className="alert alert-primary">
                            {this.state.feedbackMessage}
                        </div>
                    )}


                    {!isLoading && !TB.isObject(error) && (
                        <div>
                            {this.state.settings?.length > 1 && (
                                <div className="mb-3 text-center">
                                {this.state.settings.map((tab,i) => (
                                    <button className={`mx-1 btn btn-${this.state.selectedTabIndex == i ? 'dark' : 'primary'}`}
                                        key={`settings-tabs-${i}`}
                                        style={{display: 'inline'}}
                                        onClick={() => this.setState({selectedTabIndex: i})}>
                                        {tab.tab_type == 0 && 'Client-Side'}
                                        {tab.tab_type == 1 && 'Supply-Side'}
                                    </button>
                                ))}
                                </div>
                            )}

                            {this.renderForm()}

                        </div>
                    )}
                </div>
            </div>
        );
    }

    allSettingsProps()
    {
        console.log('this.state.settings', this.state.settings)
        let propNames = [];
        for (let tab of this.state.settings) {
            for (let group of tab.groups) {
                for (let setting of group.settings) {
                    propNames = propNames.concat(
                        TB.map(setting.options, 'settings_prop')
                    );
                }
            }
        }

        return propNames;
    }

    anyEnabled()
    {
        let authSettings = this.state.model ? this.state.model : this.context?.auth?.settings;
        let propNames = this.allSettingsProps();

        for (let name of propNames) {
            if (authSettings[name]) {
                return true;
            }
        }

        return false;
    }

    toggleAllEmailNotifications(shouldEnable)
    {
        let propNames = this.allSettingsProps();
        // console.log('toggleAllEmailNotifications propNames', propNames)

        let authSettings = {...this.state.model};
        for (let name of propNames) {
            authSettings[name] = shouldEnable;
        }

        // console.log('toggleAllEmailNotifications authSettings', authSettings)
        this.promisedState({model: authSettings});
    }

    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */
    renderFormChildren()
    {
        let showDisableAll = this.anyEnabled()
        // console.log('anyEnabled', showDisableAll)

        return (
            <div className="form-footer">
                <div className="form-buttons pl-0"
                    style={{display:'flex', justifyContent:'space-between'}}>

                    {showDisableAll && (
                        <button type="button"
                            className="btn-submit btn btn-dark"
                            onClick={this.toggleAllEmailNotifications.bind(this, false)}>
                            Disable All
                        </button>
                    )}

                    {!showDisableAll && (
                        <button type="button"
                            className="btn-submit btn btn-dark"
                            onClick={this.toggleAllEmailNotifications.bind(this, true)}>
                            Enable All
                        </button>
                    )}



                    <button type="submit" formNoValidate className="btn-submit btn btn-primary">
                        {TB.tryTrans("auth.edit_settings.submit_button")}
                    </button>
                </div>
            </div>
        );
    }
}

const styles = {
	fieldSection: {
		flexDirection: 'row',
        alignItems: 'stretch',
        padding: '15px 0'
	},
	field: {
		padding: '0 15px',
        marginTop: 0,
        marginBottom: 0,
	},
};

const NotificationSettingsPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();

    return (
        <NotificationSettings location={location}
            navigate={navigate}
            queryParams={Object.fromEntries([...searchParams])}/>
    )
}

export {
    NotificationSettingsPage,
}